module.exports = __webpack_public_path__ + "img/uprightlogo.862cd20e.png";